// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"da677f91","491":"6c920831","563":"daabec61"}[chunkId] + ".chunk.css";
};